import React, { Component } from "react";
import Collapsible from "../collapsible";

export default class FAQList extends Component {
  constructor() {
    super();
    this.state = {
      index: -1,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle(index) {
    if (index === this.state.index) index = -1;
    this.setState({ index });
  }

  render() {
    return this.list.map((question, index) => (
      <Collapsible
        toggle={this.toggle}
        title={question.q}
        index={index}
        key={index}
        show={this.state.index === index}
        headerClassName="faqHeader"
        contentClassName="faqContent"
        headerColor="color-blue"
      >
        {question.a}
      </Collapsible>
    ));
  }

  list = [
    {
      q: "How can this app help me keep fit?",
      a: (
        <p>
          Keep fit with personalized exercise routines that you can create and
          customize to your hearts content with the{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.doublethefun.ufit"
            target="_blank"
            rel="noopener noreferrer"
          >
            Workout Routines: Customizable Fitness Routines
          </a>{" "}
          app. You'll start off with standard exercise legs, abs, and
          chest routines, but then you can customize and set your own schedule
          for the entire week. You can add new routines, set the number of reps
          or duration, record instructional messages, look up videos, and set
          voice counters. You have full control on your workout routine to stay
          fit the way you want.
        </p>
      ),
    },
    {
      q: "How do you add a new routine?",
      a: (
        <p>
          On the main routine page for the day, click the plus (+) sign on the
          top right to open the Add Routine page. Click on one or more routines
          that you like to add. Then click the check mark (&#10003;) on the top
          right to add them.
        </p>
      ),
    },
    {
      q: "How do you create a new routine?",
      a: (
        <p>
          On the main routine page for the day, click the plus (+) sign on the
          top right to open the Add Routine page. Click the plus (+) sign on the
          top right again to open the New Routine page. Type in the name of the
          new routine. Then click the plus (+) sign on the top right again to
          add an exercise for the new routine. Once an exercise has been added,
          click the check mark (&#10003;) on the top right to add it. Continue
          adding as many exercises as you like. To save the new routine, click
          the check mark (&#10003;) on the New Routine page.
        </p>
      ),
    },
    {
      q: "How do you edit a routine?",
      a: (
        <p>
          To edit a routine, just click the pen/edit icon (&#x270E;) next to a
          routine. Remember to click the check mark (&#10003;) to save when
          you're done editing.
        </p>
      ),
    },
    {
      q: "How to you create a new exercise?",
      a: (
        <p>
          While editing a routine, you can click the plus sign (+) on the top
          right to add/create a new exercise. Choose whether you want the
          exercise to count by Reps or duration. Then enter in the exercise name
          and set any other settings before clicking the check mark (&#10003;)
          to save.
        </p>
      ),
    },
    {
      q: "How to you edit a exercise?",
      a: (
        <p>
          When editing a routine, you can click on the pen/edit icon (&#x270E;)
          next to an exercise to edit it. Remember to click the check mark
          (&#10003;) to save when you're done editing.
        </p>
      ),
    },
    {
      q: "How to sort/reposition a routine/exercise?",
      a: (
        <p>
          To reposition a routine or exercise, just click the burger icon
          (&#9776;) next to a routine/exercise and drag it to the position you
          like.
        </p>
      ),
    },
    {
      q: "How to set up your schedule for the week?",
      a: (
        <p>
          Click the burger icon (&#9776;) on the top left of the main routine
          page to open up the Options side menu. You'll then see the Daily
          Schedule option that opens up a weekly schedule where you can add/edit
          your routines for the entire week.
        </p>
      ),
    },
    {
      q: "How to turn off sound?",
      a: (
        <p>
          There are two screens where you can turn off sound. The first is by
          clicking on the burger icon (&#9776;) on the top left of the main
          routine page to open up the Options side menu. Then click the Settings
          option where it'll allow you to turn off the Count sound and the Tap
          Sound. You can also turn off the sound while you're doing an exercise
          by clicking on the speaker icons (&#128266;) next to the count down
          circle.
        </p>
      ),
    },
    {
      q: "How to change language?",
      a: (
        <p>
          Click the burger icon (&#9776;) on the top left of the main routine
          page to open up the Options side menu. Then click the Settings option
          where you'll be able to change to one of the supported the languages.
        </p>
      ),
    },
    {
      q: "How to customize color?",
      a: (
        <p>
          Click the burger icon (&#9776;) on the top left of the main routine
          page to open up the Options side menu. Then click the Settings option
          where you'll be able to change the header color and the background
          color.
        </p>
      ),
    },
    {
      q: "How to record new counters?",
      a: (
        <p>
          Click the burger icon (&#9776;) on the top left of the main routine
          page to open up the Options side menu. Then click the Settings option
          where you'll be able click the Record Counter option (&#x1F3A4;) to
          open up a bottom menu. You'll then see the numbers representing each
          counter. Click on the counter you wish to record over, click the
          record button (&#x1F3A4;) to start recording. You can click the
          playback button (&#x25B6;) to hear what you've recorded. Once you're
          satisfied with your recording(s), you click the X button to save and
          close out of the bottom menu.
        </p>
      ),
    },
    {
      q: "How to record new exercise messages?",
      a: (
        <p>
          When editing an exercise, you'll see the option to Record Messages.
          Just click the the record button (&#x1F3A4;) to open up a bottom menu.
          You'll then be able to record a pre-exercise messages, a mid-exercise
          message, and a post-exercise message. Click on the message type that
          you want to record over and then click the record button (&#x1F3A4;)
          to start recording. You can click the playback button (&#x25B6;) to
          hear what you've recorded. Once you're satisfied with your
          recording(s), you click the X button to save and close out of the
          bottom menu.
        </p>
      ),
    },
    {
      q: "How to search for new videos?",
      a: (
        <p>
          When editing an exercise, you'll see the Video option. Clicking on
          that will allow you to search for any intructional videos available on
          Youtube. Once you found the video you like, just click on the check
          mark (&#10003;) next to it to select it.
        </p>
      ),
    },
    {
      q: "Setting up Profile to download/share routines",
      a: (
        <p>
          Click the burger icon (&#9776;) on the top left of the main routine
          page to open up the Options side menu. Once you click on the Settings
          option, you'll see the Add Profile circle on the top of the Settings
          screen. Make sure you have an internet connection before clicking this
          Add Profile button. It'll then prompt you for your name and email.
          Fill those in and click the check mark (&#10003;) at the top right of
          the screen to save. A confirmation email will be sent to your email
          and once you've confirm it, your profile will be ready and you can
          start downloading and sharing your exercise routines.
        </p>
      ),
    },
    {
      q: "How to download new routines?",
      a: (
        <p>
          Click the burger icon (&#9776;) on the top left of the main routine
          page to open up the Options side menu. You'll then see the Download
          Routines option. To download new routines, you need to make sure
          you're connected to the internet and set up your profile in the
          Settings screen (refer to the answer above regarding setting up a
          profile). If that's done, then you'll see all available routines. Just
          select the ones you want and click the check mark (&#10003;) next to
          it to select it. Then click the check mark (&#10003;) on the top right
          corner of the screen to download the selected routines.
        </p>
      ),
    },
    {
      q: "How to share routines?",
      a: (
        <p>
          Click the burger icon (&#9776;) on the top left of the main routine
          page to open up the Options side menu. You'll then see the Share
          Routines option. To share your routines, you need to make sure you're
          connected to the internet and set up your profile in the Settings
          screen (refer to the answer above regarding setting up a profile). If
          that's done, then you'll see all available routines that can be
          shared. Just select the ones you want and click the check mark
          (&#10003;) next to it to select it. Then click the check mark
          (&#10003;) on the top right corner of the screen to share the selected
          routines.
        </p>
      ),
    },
  ];
}
